module.exports = __webpack_public_path__ + "static/img/6.9a31755.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/6.png
// module id = ga9V
// module chunks = 0